export const SECTION_ACCESS: Record<string, string[]> = {
  'company-settings': ['access_company_settings'],
  'company-profile': ['edit_company_profile'],
  'loan-center': ['view_live_loans'],
  'loan-data-exports': ['generate_reports'],
  'manage-users': ['view_users'],
  'edit-user': ['view_users'],
  'role-permissions': ['manage_role_permissions'],
  servicing: ['manage_compensation_plans', 'view_own_servicing'],
  'my-commissions': ['manage_compensation_plans', 'view_own_commissions'],
  'lo-prospects': ['view_recruiting'],
  recruiting: ['view_recruiting'],
  // Field Discovery performs privileged DDL; gate the route, not just the menu.
  'field-discovery': ['Admin'],
  // Company Reports: gate the routes (not just the sidebar) so the hub's cards
  // can't be used to open a report the user lacks access to. `view_reports`
  // users can view operational reports only; sensitive report cards stay behind
  // `generate_reports`. The LO Scoreboard also accepts the dedicated
  // `view_lo_scoreboard` permission so partners reach only the scoreboard.
  'company-reports': ['view_reports', 'generate_reports', 'view_lo_scoreboard'],
  'pipeline-performance-report': ['view_reports', 'generate_reports'],
  'pipeline-status-report': ['view_reports', 'generate_reports'],
  'funded-loan-report': ['view_reports', 'generate_reports'],
  'lo-scoreboard-report': ['generate_reports', 'view_lo_scoreboard'],
  'pickup-report': ['generate_reports'],
  'company-revenue-report': ['generate_reports'],
  'fraud-alerts-report': ['view_reports', 'generate_reports'],
  'appraisal-delivery-report': ['view_reports', 'generate_reports'],
  // The feature-flagged Secondary workspace is available to Admins and the
  // dedicated read-only viewer permission. Pick Up Analysis keeps its legacy
  // generate_reports gate until the relocation flag is on.
  secondary: ['Admin', 'view_pickup'],
  'pickup-pipeline': ['Admin', 'view_pickup'],
  // OB Builder is an admin pricing test console that hits a privileged edge fn;
  // gate the route, not just the menu.
  'ob-builder': ['Admin'],
  // Tools → My Email Notifications: the same permission the loan-access rule requires.
  'my-email-notifications': ['view_live_loans']
};

interface SectionAccessOptions {
  pickupRepriceOpportunitiesEnabled?: boolean;
}

export function getSectionPermissions(
  sectionId: string,
  options: SectionAccessOptions = {}
): string[] {
  if (sectionId === 'pickup-report' && options.pickupRepriceOpportunitiesEnabled) {
    return ['Admin', 'view_pickup'];
  }
  return SECTION_ACCESS[sectionId] ?? [];
}
